// extracted by mini-css-extract-plugin
module.exports = {"banner":"_b897d1d","onboardingActive":"_b8114a6","content":"_3453fe8","text":"_661627e","button":"_1d50083"};